module.exports = __webpack_public_path__ + "img/金币.2a88303b.png";